import { Box, ClickAwayListener, Popover } from '@mui/material';
import { useViewMode } from 'apps/wrapper/src/hooks/use-view-mode';
import { FC, ReactNode, useEffect, useState } from 'react';

export interface SearchResultsPopoverProps {
  open: boolean;
  anchorEl: Element | null;
  children: ReactNode;
  onClose: () => void;
}

export const SearchResultsPopover: FC<SearchResultsPopoverProps> = (props) => {
  const { open, anchorEl, children, onClose } = props;
  const { viewMode } = useViewMode();
  const [isSmallDesktopScreen, setIsSmallDesktopScreen] = useState(window.innerWidth < 1400);

  useEffect(() => {
    const handleResize = () => setIsSmallDesktopScreen(window.innerWidth < 1400);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent | TouchEvent) => {
    if (anchorEl && anchorEl.contains(event.target as Node)) return;
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      hideBackdrop={true}
      disableAutoFocus={true}
      disablePortal={true}
      disableEscapeKeyDown={false}
      disableEnforceFocus={true}
      disableScrollLock={true}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      sx={{
        '& .MuiPaper-root': {
          position: 'relative',
          pointerEvents: 'all',
          background: 'white',
          borderRadius: '8px',
          width: 'calc(40% - 20px)',
          marginTop: '8px',
          overflow: 'hidden',
          ...(isSmallDesktopScreen && {
            width: '50%'
          }),
          ...(viewMode === 'Tablet' && {
            width: 'calc(100% - 102px)'
          }),
          ...(viewMode === 'Phone' && {
            width: '100%',
            maxWidth: '100%',
            height: 'calc(100% - 56px)',
            borderRadius: 0,
            marginTop: 0,
            top: '56px !important',
            right: '0 !important',
            left: '0 !important',
            bottom: '0 !important'
          })
        }
      }}
    >
      <ClickAwayListener onClickAway={handleClickOutside}>
        <Box>{children}</Box>
      </ClickAwayListener>
    </Popover>
  );
};
